<template>
  <div>
    <yx-auto-complete
      :width="width"
      :placement="placement"
      :api="api.getClassroomList"
      :placeholder="placeholder"
      :immediate="immediate"
      :keys="{ searchKey: 'keyWord', nameKey: 'roomName' }"
      :query-params="queryParams"
      :display-format="displayFormat"
      :no-page="true"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    queryParams: Object,
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
    format: Boolean,
  },
  setup(props) {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
      displayFormat(it) {
        const item = it;
        if (props.format && item.status == 0) {
          return `${item.roomName}（已停用）`;
        }
        return `${item.roomName}`;
      },
    };
  },
});
</script>
